import { Modal, ModalBody, ModalHeader } from 'reactstrap';

const CommonModal = ({
    show,
    onCloseClick,
    bodyText,
    handleSubmit,
    hideButtons,
    headerText,
    saveText,
    cancelText,
    size,
    helpText,
    onHelpTextClick
}) => {
    return (
        <Modal isOpen={show} toggle={onCloseClick} centered={true} size={size ? size : 'md'}>
            <ModalHeader className="bg-soft-success">{headerText}</ModalHeader>
            <ModalBody className="py-3 px-5">
                <div>{bodyText}</div>
                {!hideButtons && (
                    <div className=" float-right">
                        {!!saveText && (
                            <button
                                id="continue"
                                type="button"
                                className="btn btn-md btn-primary "
                                data-bs-dismiss="modal"
                                onClick={handleSubmit}
                            >
                                {saveText}
                            </button>
                        )}
                        {!!helpText && (
                            <button id="cancel" type="button" className="btn btn-md ms-3 btn-primary" onClick={onHelpTextClick}>
                                {helpText}
                            </button>
                        )}
                        {!!cancelText && (
                            <button id="cancel" type="button" className="btn btn-md ms-3 btn-outline-primary" onClick={onCloseClick}>
                                {cancelText}
                            </button>
                        )}
                    </div>
                )}
            </ModalBody>
        </Modal>
    );
};
export default CommonModal;
